import {ComponentsProvider} from 'platform/components';

import {ReactNode} from 'react';
import {Provider} from 'react-redux';
import {Outlet, RouterProvider, createMemoryRouter} from 'react-router-dom';

import {fileStorageApi, metadaApi, omneticApi} from '@dms/api/base';
import {cachedApi, publicApi} from '@dms/api/core';
import {branchSlice} from '@dms/api/features';

import {createTestStore} from 'shared/web';

import {InitializeMockData} from '../../utils/InitializeMockData';

const reducers = [omneticApi, cachedApi, metadaApi, fileStorageApi, publicApi];

type ComponentMockProviderProps = {
  children: ReactNode;
};

const mockTranslation = (key: string, ...args: unknown[]) => {
  const argsObject = args[0] && typeof args[0] === 'object' ? args[0] : {};
  if (Object.keys(argsObject).length === 0) {
    return key;
  }
  return `${key}, {${Object.entries(argsObject)
    .map(([key, value]) => `${key}: ${value}`)
    .join(', ')}}`;
};

let routerInstanceCounter = 0;

export const ComponentMockProvider = (props: ComponentMockProviderProps) => {
  const instanceId = ++routerInstanceCounter;

  const router = createMemoryRouter(
    [
      {
        id: `mock-layout-${instanceId}`,
        element: (
          <Provider store={createTestStore(reducers, {[branchSlice.name]: branchSlice.reducer})}>
            <ComponentsProvider language="cs" t={mockTranslation}>
              <InitializeMockData>
                <Outlet />
              </InitializeMockData>
            </ComponentsProvider>
          </Provider>
        ),
        children: [
          {
            id: `mock-route-${instanceId}`,
            path: '*',
            element: props.children,
          },
        ],
      },
    ],
    {initialEntries: ['/']}
  );

  return <RouterProvider router={router} />;
};
